export enum SnackbarActionType {
  ShowSnack = 'snackbar/showSnack',
  HideSnack = 'snackbar/hideSnack',
}
